export const fileToBase64 = async (file: File) => {
	const dataUrl = await new Promise<string>((resolve, reject) => {
		const reader = new FileReader()
		reader.onload = () => resolve(reader.result?.toString() ?? "")
		reader.onerror = () => reject(new Error("Failed to read file"))
		reader.readAsDataURL(file)
	})

	const base64 = dataUrl.split(",")[1]
	if (!base64) {
		throw new Error("Failed to read file")
	}

	return base64
}
